import React from "react";

export default function ImageryCoveragePanel({ coverage, loading }) {
  if (loading) {
    return (
      <div className="text-xs text-fg-secondary px-3 py-2">
        Loading imagery coverage…
      </div>
    );
  }

  if (!coverage || !coverage.datasets || coverage.datasets.length === 0) {
    return (
      <div className="text-xs text-fg-secondary px-3 py-2">
        No imagery coverage for this AOI.
      </div>
    );
  }

  const { datasets, selectedDatasetId, isEligible } = coverage;

  return (
    <div className="px-3 py-2">
      <div className="text-[11px] font-semibold text-gray-400 font-mono uppercase tracking-wider mb-2">
        Imagery Coverage
      </div>

      <div className="space-y-1">
        {datasets.map(row => {
          const pct = Math.round(row.coverage_ratio * 100);
          const isSelected = row.dataset_id === selectedDatasetId;

          return (
            <div
              key={row.dataset_id}
              className={`flex items-center justify-between text-xs ${
                isSelected
                  ? "text-accent-action"
                  : "text-gray-300"
              }`}
            >
              <div className="flex items-center gap-2">
                <span>
                  {row.coverage_state === "full" ? "✓" : "◐"}
                </span>

                <span className="truncate max-w-[220px]">
                  {row.dataset_name}
                  {row.resolution_cm && (
                    <span className="ml-1 text-fg-secondary">
                      ({row.resolution_cm}cm)
                    </span>
                  )}
                </span>
              </div>

              <div className="text-gray-400">
                {row.coverage_state === "full"
                  ? "FULL"
                  : `${pct}%`}
              </div>
            </div>
          );
        })}
      </div>

      {!isEligible && (
        <div className="text-[11px] text-red-400 mt-2">
          Insufficient coverage for AI execution
        </div>
      )}
    </div>
  );
}